// dev-open-drawer.js — MV -> side-cart bridge with hard cap + cooldown

const DRAWER_SEL  = '#site-cart-sidebar';
const INPUTS_SEL  = '.cart__items input[name="updates[]"]';
const MAX_TRIES   = 4;
const DEBOUNCE_MS = 250;
const COOLDOWN_MS = 5000; // pause after we hit the cap

let running    = false;
let lastToken  = null;
let tries      = 0;
let debounceId = null;
let lockUntil  = 0;       // wall-clock until which we ignore events

const now = () => Date.now();

const drawerHasInputs = () =>
  !!document.querySelector(`${DRAWER_SEL} ${INPUTS_SEL}`);

function canRun() {
  return (
    !running &&
    now() >= lockUntil &&
    tries < MAX_TRIES &&
    drawerHasInputs() &&
    window._SKT &&
    typeof window.mvAfterCheckCartItems === 'function'
  );
}

function schedule() {
  if (!canRun()) return;               // <-- guard new schedules
  clearTimeout(debounceId);
  debounceId = setTimeout(rebindMV, DEBOUNCE_MS);
}

function rebindMV() {
  if (!canRun()) return;

  running = true;
  const prevUrl = location.pathname + location.search + location.hash;

  history.replaceState(null, '', '/cart');     // some MV builds require /cart
  window.mvExistingCartRead = false;

  const originalCb = window.mvAfterCheckCartItems;

  window.mvAfterCheckCartItems = function mvWrapped(cart) {
    try {
      const token = cart && cart.token;        // token may be undefined
      console.debug('[MV bridge] mvAfterCheckCartItems', { token, tries });

      // Reset the counter on a new cart token (new payload)
      if (token && token !== lastToken) {
        tries = 0;
        lastToken = token;
      }

      // Count this pass
      tries++;

      if (tries >= MAX_TRIES) {
        console.debug('[MV bridge] MAX_TRIES reached, stop.');
        lockUntil = now() + COOLDOWN_MS;       // prevent further schedules for a while
      }

      return originalCb.apply(this, arguments);
    } finally {
      window.mvAfterCheckCartItems = originalCb;
      history.replaceState(null, '', prevUrl);
      running = false;
    }
  };

  window._SKT._r.get(
    window.location.origin + '/cart.js?requestfrom=mv',
    window.mvAfterCheckCartItems
  );
  console.debug('[MV bridge] recheck sent');
}

// Hooks from the drawer (Local emits one or both)
document.addEventListener('cart:updated', schedule);
document.addEventListener('cart:refresh', schedule);

// First bind if the drawer is already open
if (document.querySelector(DRAWER_SEL)) schedule();

// Manual helper in console if needed
window.__mvBridgeForce = () => { tries = 0; lockUntil = 0; schedule(); };
